import { Field } from "contentful"

export default function renderBoolean(field: Field) {
  return "boolean"
}
